import React from 'react';
import { useDispatch } from 'react-redux';
import { Box, Flex, Icon, MenuGroup, MenuItem, Tooltip } from '@chakra-ui/react';
import { BsFillClipboardFill } from 'react-icons/bs';
import PropTypes from 'prop-types';

import PopupMenu from '../../../../components/PopupMenu';
import { analyticsIds } from '../../../../constants/analyticsIds';
import { EmailAutomationTriggers } from '../../../../constants/emailAutomations';
import {
  DefaultTemplateTokens,
  EmailAutomationTokens
} from '../../../../constants/emailTokens';
import { createToast } from '../../../../redux/modules/app';

const PersonalizeDropdown = ({ onClick, automationTrigger, ...props }) => {
  const dispatch = useDispatch();
  const tokenGroups = automationTrigger
    ? EmailAutomationTokens[automationTrigger]
    : DefaultTemplateTokens;

  const handleCopyClick = async (e, key) => {
    e.stopPropagation();
    e.preventDefault();
    try {
      await navigator.clipboard.writeText(key);
      dispatch(createToast({ title: 'Token Copied', type: 'info', duration: 3000 }));
    } catch {
      dispatch(createToast({ title: 'Copy failed', type: 'error', duration: 3000 }));
    }
  };

  const handleCopyKeyDown = (e, key) => {
    if (e.key === 'Enter' || e.key === ' ') {
      handleCopyClick(e, key);
    }
  };

  return (
    <Box {...props} data-analytics-id={analyticsIds.emailEditorPage.tokenSelectorPopoverButton}>
      <PopupMenu minWidth="110px" title="Tokens">
        {Object.entries(tokenGroups).map(([name, tokens]) => (
          <MenuGroup key={name} textAlign="left" title={name}>
            {
            tokens.map(key => (
              <MenuItem
                key={key}
                textTransform="none"
                value={key}
                onClick={() => onClick(key)}
              >
                <Flex justifyContent="space-between" alignItems="center" width="100%">
                  <span>{`${key}`}</span>
                  {/* Rendered as a span (not a button) so it is not an invalid
                      <button> nested inside the MenuItem's button element. */}
                  <Tooltip label={`Copy ${key}`} placement="right">
                    <Box
                      as="span"
                      role="button"
                      tabIndex={0}
                      aria-label={`Copy ${key}`}
                      display="inline-flex"
                      alignItems="center"
                      cursor="pointer"
                      ml={2}
                      _hover={{ opacity: 0.7 }}
                      onClick={e => handleCopyClick(e, key)}
                      onKeyDown={e => handleCopyKeyDown(e, key)}
                    >
                      <Icon as={BsFillClipboardFill} />
                    </Box>
                  </Tooltip>
                </Flex>
              </MenuItem>
            ))
          }
          </MenuGroup>
        ))}
      </PopupMenu>
    </Box>
  );
};

PersonalizeDropdown.propTypes = {
  onClick: PropTypes.func.isRequired,
  automationTrigger: PropTypes.oneOf(Object.values(EmailAutomationTriggers))
};

export default PersonalizeDropdown;
